var _rect, _rect2, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccountProduct(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 210,
    viewBox: "0 0 375 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6386_338502",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 375,
    height: 210
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 210,
    fill: "url(#paint0_linear_6386_338502)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6386_338502)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6386_338502",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -15,
    width: 375,
    height: 210
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: -15,
    width: 375,
    height: 210,
    fill: "url(#paint1_linear_6386_338502)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6386_338502)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6386_338502)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.4795 42.2674C88.8075 39.9775 86.7037 38.304 84.1979 38.304C82.6907 38.304 81.3216 38.9143 80.3293 39.8957C79.3748 37.3541 76.9255 35.5423 74.0492 35.5423C73.8922 35.5423 73.7352 35.5486 73.5782 35.5611C71.6251 33.1328 68.6294 31.5789 65.2758 31.5789C61.3696 31.5789 57.9595 33.6801 56.1005 36.8193C54.8947 33.7493 51.9117 31.5789 48.4199 31.5789C45.1731 31.5789 42.3659 33.4536 41.0219 36.1839C39.7722 31.2581 35.3195 27.6155 30.0191 27.6155C24.7187 27.6155 20.2911 31.2329 19.0288 36.1336C17.9361 35.1396 16.4791 34.5294 14.8839 34.5294C12.8366 34.5294 11.0154 35.5297 9.89751 37.071C8.77336 35.5297 6.9584 34.5294 4.91107 34.5294C2.86375 34.5294 1.12415 35.4982 0 36.9829V42.2674H89.4795Z",
    fill: "url(#paint2_linear_6386_338502)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M375 79.2273C373.059 77.1701 370.309 75.8931 367.263 75.8931C363.357 75.8931 359.947 77.9943 358.088 81.1335C356.882 78.0635 353.899 75.8931 350.407 75.8931C347.16 75.8931 344.353 77.7678 343.009 80.4981C341.759 75.5722 337.307 71.9297 332.006 71.9297C326.706 71.9297 322.278 75.547 321.016 80.4478C319.923 79.4538 318.466 78.8436 316.871 78.8436C314.824 78.8436 313.002 79.8438 311.885 81.3851C310.76 79.8438 308.945 78.8436 306.898 78.8436C304.135 78.8436 301.792 80.6617 301.007 83.1718C300.417 82.8195 299.726 82.6119 298.985 82.6119C297.377 82.6119 296.002 83.5744 295.38 84.9522C294.495 83.9456 293.207 83.3039 291.763 83.3039C289.647 83.3039 287.85 84.6754 287.204 86.5753H375.006V79.2273H375Z",
    fill: "url(#paint3_linear_6386_338502)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M312.343 10.8059C311.144 8.20767 308.518 6.40214 305.473 6.40214C303.224 6.40214 301.202 7.38354 299.82 8.95002C298.181 6.45876 295.368 4.8168 292.171 4.8168C288.975 4.8168 286.356 6.34552 284.698 8.69208C283.932 4.40788 280.189 1.14912 275.692 1.14912C274.197 1.14912 272.791 1.50771 271.547 2.1431C269.349 -1.87688 265.091 -4.6009 260.193 -4.6009C255.294 -4.6009 251.262 -2.01528 249.014 1.83484C247.406 -4.73301 241.49 -9.61487 234.432 -9.61487C229.162 -9.61487 224.528 -6.89084 221.846 -2.7765C220.389 -3.39931 218.781 -3.74532 217.098 -3.74532C211.295 -3.74532 206.447 0.350153 205.285 5.81707C203.646 2.60864 200.318 0.406773 196.474 0.406773C192.355 0.406773 188.825 2.92948 187.337 6.51538C186.495 5.83595 185.434 5.42703 184.266 5.42703C181.572 5.42703 179.386 7.61632 179.386 10.3152C179.386 10.334 179.386 10.3529 179.386 10.3718C177.904 7.71068 175.072 5.91773 171.812 5.91773C168.383 5.91773 165.419 7.91199 164.012 10.8059H312.343Z",
    fill: "url(#paint4_linear_6386_338502)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M148.218 -15L149.819 24.3945H140.43L142.032 -15H148.218Z",
    fill: "#D3E6F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M319.414 67.0479L209.97 75.9245L211.622 88.8652L319.414 69.3944V67.0479Z",
    fill: "#D3E6F8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M209.97 100.604L375 94.0994V105.341L200.173 125.485L209.97 100.604Z",
    fill: "#D3E6F8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 69.407L80.3293 75.9245L78.6777 88.8652L0 74.6537V69.407Z",
    fill: "#D3E6F8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3293 100.604L0 97.4399V115.099L90.1264 125.485L80.3293 100.604Z",
    fill: "#D3E6F8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M315.904 167.73C333.631 167.73 348.002 153.334 348.002 135.576C348.002 117.818 333.631 103.423 315.904 103.423C298.177 103.423 283.806 117.818 283.806 135.576C283.806 153.334 298.177 167.73 315.904 167.73Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M145.128 157.557C181.872 157.557 211.66 127.718 211.66 90.9098C211.66 54.1015 181.872 24.2625 145.128 24.2625C108.383 24.2625 78.596 54.1015 78.596 90.9098C78.596 127.718 108.383 157.557 145.128 157.557Z",
    fill: "#EFF8FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M338.904 139.918C341.306 127.183 332.948 114.909 320.236 112.503C307.523 110.097 295.271 118.47 292.869 131.204C290.467 143.938 298.825 156.212 311.537 158.618C324.25 161.025 336.502 152.652 338.904 139.918Z",
    fill: "#D3E6F8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M315.904 141.559C319.202 141.559 321.876 138.881 321.876 135.576C321.876 132.272 319.202 129.594 315.904 129.594C312.605 129.594 309.931 132.272 309.931 135.576C309.931 138.881 312.605 141.559 315.904 141.559Z",
    fill: "#E5F3FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M145.128 104.228L79.1863 99.8054C78.797 96.8926 78.596 93.9295 78.596 90.9098C78.596 54.1009 108.383 24.2625 145.128 24.2625C181.873 24.2625 211.66 54.1009 211.66 90.9098C211.66 93.9232 211.459 96.8926 211.069 99.8054L145.128 104.228Z",
    fill: "#E5F3FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M145.128 147.63C159.234 147.63 170.669 136.175 170.669 122.044C170.669 107.914 159.234 96.4585 145.128 96.4585C131.022 96.4585 119.587 107.914 119.587 122.044C119.587 136.175 131.022 147.63 145.128 147.63Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M146.761 67.5637L179.556 64.7453C186.319 64.7265 193.278 74.8676 196.349 79.9508L193.24 83.3291C193.24 83.3291 190.703 80.6491 185.044 80.7183L146.767 83.8009V67.5637H146.761Z",
    fill: "#D3E6F8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M144.374 67.5637L111.579 64.7454C105.368 64.2421 97.8572 74.8676 94.7862 79.9508L97.8949 83.3291C97.8949 83.3291 100.432 80.6491 106.09 80.7183L144.368 83.8009V67.5637H144.374Z",
    fill: "#D3E6F8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M185.39 82.3099C184.303 73.6975 178.011 65.1983 177.948 65.1165L179.449 63.9904C179.719 64.3553 186.1 72.9615 187.249 82.0772L185.39 82.3099Z",
    fill: "#E5F3FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M168.452 83.2913C167.347 74.5216 163.799 64.6636 163.761 64.5629L165.526 63.9212C165.563 64.0219 169.181 74.0813 170.318 83.0523L168.459 83.2851L168.452 83.2913Z",
    fill: "#E5F3FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M105.061 82.3099L103.202 82.0772C104.351 72.9615 110.732 64.3553 111.002 63.9904L112.503 65.1165C112.44 65.1983 106.147 73.6975 105.061 82.3099Z",
    fill: "#E5F3FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M121.998 83.2913L120.139 83.0586C121.27 74.0875 124.893 64.0281 124.931 63.9275L126.696 64.5692C126.658 64.6698 123.11 74.5342 122.004 83.2976L121.998 83.2913Z",
    fill: "#E5F3FF"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.68,
    d: "M174.381 146.888L375 96.144V146.774L174.381 146.888Z",
    fill: "url(#paint5_linear_6386_338502)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.68,
    d: "M273.72 -15L0 54.233V-14.849L273.72 -15Z",
    fill: "url(#paint6_linear_6386_338502)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.68,
    d: "M0 66.7899L321.876 -15H375V-12.9932L0 81.9639V66.7899Z",
    fill: "url(#paint7_linear_6386_338502)"
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M375 147.888H0V235H375V147.888Z",
    fill: "url(#paint8_linear_6386_338502)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M375 146.164H0V147.894H375V146.164Z",
    fill: "url(#paint9_linear_6386_338502)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M356.455 -15H346.708V146.164H356.455V-15Z",
    fill: "url(#paint10_linear_6386_338502)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3297 -15H18.5829V146.164H28.3297V-15Z",
    fill: "url(#paint11_linear_6386_338502)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M243.337 -15H241.076V146.164H243.337V-15Z",
    fill: "url(#paint12_linear_6386_338502)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M133.962 -15H131.701V146.164H133.962V-15Z",
    fill: "url(#paint13_linear_6386_338502)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M375 18.3552H0V19.6511H375V18.3552Z",
    fill: "url(#paint14_linear_6386_338502)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M375 105.845H0V107.141H375V105.845Z",
    fill: "url(#paint15_linear_6386_338502)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M375 168.592V235H6.5816L268.96 168.585L375 168.592Z",
    fill: "url(#paint16_linear_6386_338502)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M375 147.8H0V166.862H375V147.8Z",
    fill: "url(#paint17_linear_6386_338502)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M375 166.862H0V168.592H375V166.862Z",
    fill: "url(#paint18_linear_6386_338502)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M179.298 168.585L0 214.107V227.08L231.241 168.585H179.298Z",
    fill: "url(#paint19_linear_6386_338502)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.14
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M0.163284 222.141C0.106762 222.141 0.0565213 222.141 0 222.135V218.712L73.2642 199.657C74.1748 199.418 75.1042 199.965 75.3429 200.884C75.5815 201.796 75.0352 202.727 74.1183 202.966L0.590334 222.084C0.44589 222.122 0.301447 222.141 0.163284 222.141Z",
    fill: "url(#paint20_linear_6386_338502)"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6882 235L225.752 199.651C226.663 199.418 227.592 199.965 227.831 200.877C228.07 201.79 227.517 202.721 226.606 202.96L102.837 235H88.6945H88.6882Z",
    fill: "url(#paint21_linear_6386_338502)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.14
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M171.58 235L307.997 199.651C308.908 199.418 309.837 199.965 310.076 200.877C310.314 201.79 309.762 202.721 308.851 202.96L185.082 235H171.586H171.58Z",
    fill: "url(#paint22_linear_6386_338502)"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7569 235L148.89 201.305H157.556C157.556 202.066 157.041 202.765 156.269 202.96L29.7491 235H15.7569Z",
    fill: "url(#paint23_linear_6386_338502)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M138.257 199.795L154.85 190.51L215.742 195.712L210.366 201.305H138.439C137.535 201.305 137.378 200.009 138.257 199.795Z",
    fill: "url(#paint24_linear_6386_338502)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M170.192 166.893C169.696 166.893 169.288 166.49 169.288 165.987V144.069H156.696V165.987C156.696 166.484 156.294 166.893 155.792 166.893C155.289 166.893 154.887 166.49 154.887 165.987V143.163C154.887 142.666 155.289 142.257 155.792 142.257H170.192C170.688 142.257 171.096 142.66 171.096 143.163V165.987C171.096 166.484 170.694 166.893 170.192 166.893Z",
    fill: "url(#paint25_linear_6386_338502)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M170.192 147.536C169.407 147.536 168.773 146.9 168.773 146.114V144.277H157.136V146.114C157.136 146.9 156.501 147.536 155.716 147.536C154.931 147.536 154.297 146.9 154.297 146.114V142.855C154.297 142.069 154.931 141.433 155.716 141.433H170.192C170.977 141.433 171.611 142.069 171.611 142.855V146.114C171.611 146.9 170.977 147.536 170.192 147.536Z",
    fill: "url(#paint26_linear_6386_338502)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M181.816 154.613H143.608C136.229 154.613 130.244 160.608 130.244 168V195.134C130.244 197.216 131.933 198.908 134.012 198.908H191.419C193.498 198.908 195.187 197.216 195.187 195.134V168C195.187 160.608 189.202 154.613 181.823 154.613H181.816Z",
    fill: "url(#paint27_linear_6386_338502)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M140.757 198.915H134.502V198.94C134.502 200.236 135.551 201.293 136.851 201.293H138.414C139.708 201.293 140.763 200.242 140.763 198.94V198.915H140.757Z",
    fill: "url(#paint28_linear_6386_338502)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M190.621 198.915H184.366V198.94C184.366 200.236 185.415 201.293 186.715 201.293H188.279C189.572 201.293 190.628 200.242 190.628 198.94V198.915H190.621Z",
    fill: "url(#paint29_linear_6386_338502)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M192.047 196.587H133.466C133.07 196.587 132.756 196.266 132.756 195.876V181.111C132.756 173.782 138.71 167.818 146.026 167.818H179.487C186.803 167.818 192.756 173.782 192.756 181.111V195.876C192.756 196.272 192.436 196.587 192.047 196.587ZM134.175 195.165H191.337V181.111C191.337 174.568 186.024 169.24 179.487 169.24H146.026C139.495 169.24 134.175 174.562 134.175 181.111V195.165Z",
    fill: "url(#paint30_linear_6386_338502)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M203.182 138.577C202.685 138.577 202.277 138.174 202.277 137.671V89.5509H184.278V137.671C184.278 138.168 183.876 138.577 183.374 138.577C182.872 138.577 182.47 138.174 182.47 137.671V88.645C182.47 88.148 182.872 87.7391 183.374 87.7391H203.182C203.678 87.7391 204.086 88.1417 204.086 88.645V137.671C204.086 138.168 203.684 138.577 203.182 138.577Z",
    fill: "url(#paint31_linear_6386_338502)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M203.182 97.7041C202.397 97.7041 201.762 97.0687 201.762 96.2823V89.7648H184.718V96.2823C184.718 97.0687 184.084 97.7041 183.299 97.7041C182.514 97.7041 181.879 97.0687 181.879 96.2823V88.343C181.879 87.5567 182.514 86.9213 183.299 86.9213H203.182C203.967 86.9213 204.601 87.5567 204.601 88.343V96.2823C204.601 97.0687 203.967 97.7041 203.182 97.7041Z",
    fill: "url(#paint32_linear_6386_338502)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M208.821 138.646H177.358C171.599 138.646 166.926 143.327 166.926 149.096V192.812C166.926 196.329 169.771 199.172 173.275 199.172H212.897C216.408 199.172 219.246 196.323 219.246 192.812V149.096C219.246 143.327 214.574 138.646 208.815 138.646H208.821Z",
    fill: "url(#paint33_linear_6386_338502)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M166.926 183.262V192.806C166.926 196.323 169.771 199.166 173.275 199.166H212.897C216.408 199.166 219.246 196.316 219.246 192.806V183.262H166.92H166.926Z",
    fill: "url(#paint34_linear_6386_338502)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M179.298 199.172H173.043V199.198C173.043 200.494 174.092 201.551 175.392 201.551H176.956C178.249 201.551 179.304 200.5 179.304 199.198V199.172H179.298Z",
    fill: "url(#paint35_linear_6386_338502)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M213.494 199.172H207.238V199.198C207.238 200.494 208.287 201.551 209.587 201.551H211.151C212.445 201.551 213.5 200.5 213.5 199.198V199.172H213.494Z",
    fill: "url(#paint36_linear_6386_338502)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M209.424 145.315H176.761C174.479 145.315 172.629 147.168 172.629 149.454V176.657C172.629 178.943 174.479 180.796 176.761 180.796H209.424C211.706 180.796 213.556 178.943 213.556 176.657V149.454C213.556 147.168 211.706 145.315 209.424 145.315Z",
    fill: "url(#paint37_linear_6386_338502)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M215.742 159.671C215.346 159.671 215.032 159.35 215.032 158.96V149.951C215.032 146.246 212.024 143.226 208.319 143.226H177.854C174.155 143.226 171.14 146.24 171.14 149.951V158.96C171.14 159.356 170.82 159.671 170.431 159.671C170.041 159.671 169.721 159.35 169.721 158.96V149.951C169.721 145.459 173.37 141.804 177.854 141.804H208.319C212.803 141.804 216.451 145.459 216.451 149.951V158.96C216.451 159.356 216.131 159.671 215.742 159.671Z",
    fill: "url(#paint38_linear_6386_338502)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M170.431 165.647C169.878 165.647 169.438 165.201 169.438 164.653V158.117C169.438 157.563 169.884 157.123 170.431 157.123C170.977 157.123 171.423 157.57 171.423 158.117V164.653C171.423 165.207 170.977 165.647 170.431 165.647Z",
    fill: "url(#paint39_linear_6386_338502)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M207.251 149.026H178.921C177.413 149.026 176.189 150.252 176.189 151.763V174.782C176.189 176.293 177.413 177.519 178.921 177.519H207.251C208.76 177.519 209.983 176.293 209.983 174.782V151.763C209.983 150.252 208.76 149.026 207.251 149.026Z",
    fill: "url(#paint40_linear_6386_338502)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M207.64 155.538H180.341C179.945 155.538 179.631 155.217 179.631 154.827C179.631 154.437 179.951 154.116 180.341 154.116H207.64C208.036 154.116 208.35 154.437 208.35 154.827C208.35 155.217 208.03 155.538 207.64 155.538Z",
    fill: "url(#paint41_linear_6386_338502)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M180.341 162.382C179.788 162.382 179.342 161.936 179.342 161.388V154.852C179.342 154.298 179.788 153.858 180.341 153.858C180.893 153.858 181.333 154.305 181.333 154.852V161.388C181.333 161.942 180.887 162.382 180.341 162.382Z",
    fill: "url(#paint42_linear_6386_338502)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M199.941 184.231L209.399 167.591L201.442 163.056L189.409 184.231H199.941Z",
    fill: "url(#paint43_linear_6386_338502)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M198.679 184.162L207.427 168.743L201.706 165.547L191.281 184.162H198.679Z",
    fill: "url(#paint44_linear_6386_338502)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M193.303 184.502C193.246 184.502 193.19 184.489 193.14 184.458C192.976 184.363 192.92 184.156 193.008 183.992L201.838 168.233C201.932 168.07 202.133 168.013 202.302 168.101C202.466 168.195 202.522 168.403 202.434 168.567L193.604 184.326C193.542 184.439 193.428 184.502 193.309 184.502H193.303Z",
    fill: "url(#paint45_linear_6386_338502)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M201.071 174.801C201.015 174.801 200.958 174.788 200.908 174.757C200.745 174.663 200.688 174.455 200.776 174.291L204.168 168.239C204.262 168.076 204.463 168.019 204.632 168.107C204.796 168.202 204.852 168.409 204.764 168.573L201.373 174.625C201.31 174.738 201.197 174.801 201.078 174.801H201.071Z",
    fill: "url(#paint46_linear_6386_338502)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M207.948 184.231L214.172 173.279L206.215 168.743L197.41 184.231H207.948Z",
    fill: "url(#paint47_linear_6386_338502)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M206.629 184.231L212.426 174.153L206.435 170.724L198.785 184.231H206.629Z",
    fill: "url(#paint48_linear_6386_338502)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M203.91 179.016C203.854 179.016 203.797 179.003 203.747 178.972C203.583 178.878 203.527 178.67 203.615 178.506L207.006 172.454C207.1 172.291 207.301 172.234 207.471 172.322C207.634 172.417 207.691 172.624 207.603 172.788L204.212 178.84C204.149 178.953 204.036 179.016 203.916 179.016H203.91Z",
    fill: "url(#paint49_linear_6386_338502)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M205.606 179.853C205.549 179.853 205.493 179.84 205.442 179.809C205.279 179.714 205.223 179.507 205.311 179.343L208.702 173.291C208.796 173.127 208.997 173.071 209.167 173.159C209.33 173.253 209.386 173.461 209.298 173.624L205.907 179.676C205.844 179.79 205.731 179.853 205.612 179.853H205.606Z",
    fill: "url(#paint50_linear_6386_338502)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M207.427 180.84C207.37 180.84 207.314 180.828 207.264 180.796C207.1 180.702 207.044 180.494 207.132 180.331L210.523 174.279C210.617 174.115 210.818 174.059 210.988 174.147C211.151 174.241 211.208 174.449 211.12 174.612L207.728 180.664C207.666 180.777 207.553 180.84 207.433 180.84H207.427Z",
    fill: "url(#paint51_linear_6386_338502)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M219.252 183.262H166.926V184.684H219.252V183.262Z",
    fill: "url(#paint52_linear_6386_338502)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M170.431 191.51C169.878 191.51 169.438 191.063 169.438 190.516V183.98C169.438 183.426 169.884 182.986 170.431 182.986C170.977 182.986 171.423 183.432 171.423 183.98V190.516C171.423 191.07 170.977 191.51 170.431 191.51Z",
    fill: "url(#paint53_linear_6386_338502)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M173.621 191.51C173.068 191.51 172.629 191.063 172.629 190.516V183.98C172.629 183.426 173.075 182.986 173.621 182.986C174.167 182.986 174.613 183.432 174.613 183.98V190.516C174.613 191.07 174.167 191.51 173.621 191.51Z",
    fill: "url(#paint54_linear_6386_338502)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M204.902 136.054H181.258C179.863 136.054 178.733 137.187 178.733 138.583V138.609H207.427V138.583C207.427 137.187 206.296 136.054 204.902 136.054Z",
    fill: "url(#paint55_linear_6386_338502)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M103.252 103.945C102.894 106.43 101.657 107.518 100.991 108.506C100.325 109.494 99.7664 113.035 97.5495 113.664L98.5543 116.904C98.5543 116.904 105.651 116.055 106.43 114.432C106.656 113.954 106.561 113.237 106.737 112.494C106.806 112.205 107.284 112.004 107.277 111.601C107.277 111.079 106.875 110.953 106.894 110.538C106.926 109.808 107.698 109.588 107.51 108.814C107.328 108.072 103.34 108.531 103.34 108.531C103.34 108.531 104.621 105.744 104.401 104.782C104.257 104.165 103.264 103.951 103.264 103.951L103.252 103.945Z",
    fill: "url(#paint56_linear_6386_338502)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6028 201.777C69.6028 201.777 69.584 201.777 69.5777 201.777C69.3202 201.764 69.1193 201.538 69.1318 201.28C69.1381 201.16 69.8666 189.428 76.6429 177.638C80.6245 170.699 85.8935 165.094 92.2867 160.98C100.275 155.833 110.053 153.015 121.358 152.594C121.621 152.581 121.835 152.789 121.847 153.047C121.86 153.304 121.653 153.525 121.395 153.537C96.2306 154.475 83.6264 167.403 77.4844 178.085C70.8086 189.686 70.0864 201.23 70.0801 201.343C70.0676 201.595 69.8603 201.79 69.6091 201.79L69.6028 201.777Z",
    fill: "url(#paint57_linear_6386_338502)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2947 80.215C51.2774 81.3537 43.8605 82.2659 43.8605 90.287C43.8605 99.2957 52.6967 99.2077 53.5257 100.623C47.5093 100.384 45.8513 117.307 61.9536 112.475C61.9536 112.475 66.2492 98.7484 69.0125 91.5515C70.7835 86.9401 53.3184 79.0763 52.301 80.2213L52.2947 80.215Z",
    fill: "url(#paint58_linear_6386_338502)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M149.43 162.238C149.097 162.238 148.758 162.181 148.425 162.055L134.383 156.89C134.313 156.865 134.251 156.84 134.188 156.809C132.542 156.066 130.106 155.739 127.826 155.966L109.551 157.746C95.3891 159.583 85.6172 155.783 78.797 145.793L52.2633 106.908C51.3527 105.574 51.6919 103.75 53.0295 102.838C54.3609 101.925 56.1822 102.265 57.0928 103.605L83.6264 142.49C89.1404 150.574 96.9214 153.487 108.841 151.933C108.873 151.933 108.904 151.927 108.935 151.92L127.261 150.134C130.501 149.819 133.949 150.297 136.499 151.423L150.447 156.551C151.967 157.111 152.739 158.79 152.187 160.313C151.753 161.502 150.629 162.231 149.442 162.238H149.43Z",
    fill: "url(#paint59_linear_6386_338502)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6912 202.651C73.6535 202.651 73.6096 202.651 73.5719 202.651C72.8308 202.589 72.2907 201.934 72.3535 201.192C72.3975 200.701 73.5091 188.962 81.3969 176.858C86.0443 169.737 92.0795 163.987 99.3393 159.772C108.383 154.525 119.342 151.669 131.914 151.279C132.649 151.266 133.271 151.839 133.296 152.581C133.321 153.323 132.737 153.94 131.996 153.965C110.009 154.644 93.7437 162.842 83.6452 178.324C76.1153 189.874 75.0352 201.311 75.0289 201.425C74.9661 202.123 74.382 202.651 73.6912 202.651Z",
    fill: "url(#paint60_linear_6386_338502)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M103.528 151.744C112.521 150.587 142.735 129.965 142.735 129.965L199.395 135.884L199.853 131.078C199.853 131.078 145.856 116.609 139.306 116.628C134.364 116.64 100.074 128.417 100.074 128.417C100.074 128.417 94.5287 152.902 103.528 151.744Z",
    fill: "url(#paint61_linear_6386_338502)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0298 56.2398C89.4669 55.0885 89.1529 68.2935 87.1182 71.59C94.4157 78.9002 88.8955 89.3811 85.8245 93.7785C92.2239 95.5526 93.2287 104.643 93.2287 104.643C93.2287 104.643 89.3288 102.649 83.5071 102.856C77.6854 103.064 58.0599 93.1557 58.0599 93.1557L71.7381 55.3842C71.7381 55.3842 76.5926 57.3848 83.0361 56.2335L83.0298 56.2398Z",
    fill: "url(#paint62_linear_6386_338502)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4974 91.9919C81.4974 91.9919 78.9916 89.6453 76.4859 91.0231C63.8 98.0187 82.923 128.656 86.0128 128.732C89.1027 128.807 101.104 112.689 101.104 112.689L100.225 111.431L87.5578 117.565C87.5578 117.565 85.5921 94.2504 81.4974 91.9919Z",
    fill: "url(#paint63_linear_6386_338502)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4974 91.9919C81.4974 91.9919 78.9917 89.6453 76.4859 91.0231C70.1806 94.4957 74.3444 103.687 80.5115 112.054L90.7858 106.619C87.5389 100.177 83.6327 93.1683 81.4974 91.9856V91.9919Z",
    fill: "#EEA601"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0626 134.846C82.0626 134.846 85.5544 140.942 86.4838 143.144C87.4133 145.346 91.3635 154.594 104.546 151.53C117.728 148.467 118.688 114.979 118.688 114.979C118.688 114.979 129.811 129.883 136.612 142.773H141.24C141.24 142.773 131.035 91.8849 121.276 91.8723C109.092 91.8597 94.2147 130.575 94.2147 130.575L82.0626 134.853V134.846Z",
    fill: "url(#paint64_linear_6386_338502)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5724 99.9186C76.1279 97.2701 71.6565 90.9098 75.3555 84.8264C79.0545 78.7429 68.6734 75.2828 68.6734 75.2828C68.6734 75.2828 69.2135 87.8146 65.8096 90.3877C62.4058 92.9607 77.5724 99.9186 77.5724 99.9186Z",
    fill: "url(#paint65_linear_6386_338502)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0626 134.846C79.0293 129.203 72.2216 125.158 69.1192 121.107C65.2193 116.017 60.8734 107.852 62.098 99.1762C63.599 88.5444 66.8333 86.9338 74.0743 90.1171C81.3153 93.3004 78.6148 93.2564 83.1617 98.1822C86.9863 102.315 91.037 102.58 94.0954 105.36C95.521 113.526 92.2993 116.08 92.2993 116.08C92.2993 116.08 95.5963 122.604 96.5384 126.769C97.4804 130.933 93.4799 134.224 93.4799 134.224L82.0564 134.846H82.0626Z",
    fill: "#D66855"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0626 134.846C79.0293 129.203 72.2216 125.158 69.1192 121.107C65.2193 116.017 60.8734 107.852 62.098 99.1762C63.599 88.5444 66.8333 86.9338 74.0743 90.1171C81.3153 93.3004 78.6148 93.2564 83.1617 98.1822C86.9863 102.315 91.037 102.58 94.0954 105.36C95.521 113.526 92.2993 116.08 92.2993 116.08C92.2993 116.08 95.5963 122.604 96.5384 126.769C97.4804 130.933 93.4799 134.224 93.4799 134.224L82.0564 134.846H82.0626Z",
    fill: "url(#paint66_linear_6386_338502)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4033 81.1838C68.4033 81.1838 71.1163 85.8204 74.0429 88.3305C74.2313 87.0974 74.8467 85.6568 75.3492 84.8264C76.3728 83.1404 76.3163 81.662 75.7008 80.3975L68.6985 77.0066C68.6985 77.881 68.4661 79.9319 68.397 81.1838H68.4033Z",
    fill: "url(#paint67_linear_6386_338502)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8332 99.8242C79.5946 99.8242 79.3873 99.6418 79.3622 99.3902C79.1047 96.3893 79.3936 92.9104 79.6762 89.5447C80.0844 84.6376 80.4738 80.0011 79.1361 77.5162C79.0105 77.2897 79.0984 77.0003 79.3245 76.8745C79.5506 76.7487 79.8395 76.8367 79.9651 77.0632C81.4346 79.7935 81.039 84.5684 80.6182 89.6202C80.3419 92.9418 80.053 96.383 80.3042 99.3021C80.3293 99.56 80.1347 99.7928 79.8772 99.8117C79.8646 99.8117 79.852 99.8117 79.8332 99.8117V99.8242Z",
    fill: "#E0DEEC"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4941 59.9075C81.4095 60.4674 84.2042 63.3739 84.5496 66.5445C85.2153 72.6972 85.6989 78.0446 82.8163 85.1849C82.5776 85.77 82.0689 86.1915 81.4472 86.2984C79.3245 86.6696 74.225 86.764 70.055 80.4981C64.629 72.3638 68.598 56.7242 79.4941 59.9075Z",
    fill: "url(#paint68_linear_6386_338502)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9264 74.012C85.7616 76.2328 87.495 76.3397 87.5578 76.8933C87.6206 77.4469 86.3708 78.8121 84.7505 79.2273C83.1303 79.6425 84.9264 74.012 84.9264 74.012Z",
    fill: "url(#paint69_linear_6386_338502)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M136.53 142.087C136.53 142.087 134.533 143.811 134.326 144.906C134.119 146 151.578 153.996 151.578 153.996L141.504 142.767L136.53 142.087Z",
    fill: "url(#paint70_linear_6386_338502)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M140.763 146.07C140.148 146.126 138.772 145.875 137.849 145.264C135.626 143.805 135.255 142.767 134.973 142.767C134.69 142.767 132.436 145.12 132.461 147.108C132.486 149.102 139.953 149.958 139.953 149.958L140.763 146.063V146.07Z",
    fill: "url(#paint71_linear_6386_338502)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M156.727 154.896C156.803 154.632 156.407 153.795 155.032 153.179C147.577 149.825 144.337 143.188 144.337 143.188C144.337 143.188 140.135 144.661 141.196 150.423L148.381 153.034L156.721 154.896H156.727Z",
    fill: "url(#paint72_linear_6386_338502)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M146.968 152.31C147.502 152.147 150.786 150.826 149.945 149.662C147.753 147.529 146.07 144.516 144.462 144.793C142.854 145.069 139.677 146.737 138.025 146.208C136.373 145.673 134.332 143.295 134.332 143.295L133.365 144.541C133.365 144.541 138.352 148.964 138.954 149.599C139.551 150.241 146.968 152.317 146.968 152.317V152.31Z",
    fill: "url(#paint73_linear_6386_338502)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M156.727 154.896C157.355 155.336 156.589 157.406 156.589 157.406C156.589 157.406 150.523 156.777 145.75 154.965C137.529 151.845 131.582 149.97 131.67 149.473C131.757 148.982 132.455 147.114 132.455 147.114C132.455 147.114 140.782 150.366 143.891 151.367C150.221 153.405 156.721 154.896 156.721 154.896H156.727Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M156.589 157.4C156.589 157.4 152.658 156.991 148.638 155.884L149.216 153.757C149.216 153.757 154.052 155.003 156.972 155.506C157.01 156.274 156.595 157.4 156.595 157.4H156.589Z",
    fill: "#ECEBF1"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M143.639 145C143.941 144.906 144.217 144.837 144.462 144.793C146.07 144.516 147.753 147.535 149.945 149.662C150.252 150.09 150.045 150.631 149.241 151.184C148.437 150.612 145.392 147.668 143.646 145H143.639Z",
    fill: "url(#paint74_linear_6386_338502)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M145.172 146.258C145.027 146.258 144.883 146.189 144.789 146.063C144.638 145.849 144.688 145.56 144.895 145.403L145.611 144.893C145.825 144.742 146.114 144.793 146.271 145C146.422 145.214 146.371 145.503 146.164 145.661L145.448 146.17C145.367 146.227 145.272 146.258 145.172 146.258Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M146.359 147.567C146.214 147.567 146.076 147.504 145.982 147.378C145.825 147.171 145.869 146.875 146.076 146.718L146.861 146.126C147.068 145.969 147.364 146.013 147.521 146.221C147.678 146.428 147.634 146.724 147.426 146.881L146.641 147.473C146.56 147.536 146.459 147.567 146.359 147.567Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M147.565 148.907C147.42 148.907 147.282 148.844 147.188 148.718C147.031 148.511 147.068 148.215 147.276 148.058L148.023 147.492C148.23 147.334 148.525 147.372 148.682 147.58C148.839 147.787 148.802 148.083 148.594 148.24L147.847 148.806C147.759 148.869 147.659 148.901 147.565 148.901V148.907Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M148.77 150.278C148.638 150.278 148.513 150.228 148.419 150.121C148.243 149.926 148.262 149.63 148.456 149.454L149.16 148.832C149.354 148.655 149.65 148.674 149.825 148.869C150.001 149.064 149.982 149.36 149.788 149.536L149.084 150.159C148.996 150.241 148.883 150.278 148.77 150.278Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M199.426 135.998C199.426 135.998 201.637 137.438 202.742 137.325C203.847 137.218 206.629 118.194 206.629 118.194L198.685 131.022L199.426 135.991V135.998Z",
    fill: "url(#paint75_linear_6386_338502)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M202.057 130.82C202.283 131.399 202.428 132.789 202.101 133.846C201.323 136.388 200.437 137.042 200.512 137.313C200.588 137.583 203.477 139.093 205.373 138.514C207.276 137.929 206.014 130.512 206.014 130.512L202.057 130.82Z",
    fill: "url(#paint76_linear_6386_338502)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M206.052 112.998C205.775 112.998 205.091 113.614 204.877 115.111C203.753 123.221 198.296 128.191 198.296 128.191C198.296 128.191 200.883 131.82 206.108 129.185L206.598 121.541L206.052 112.998Z",
    fill: "url(#paint77_linear_6386_338502)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M206.303 123.101C205.995 122.636 203.81 119.842 202.93 120.981C201.498 123.686 199.081 126.152 199.797 127.618C200.512 129.084 202.999 131.676 202.949 133.412C202.899 135.148 201.191 137.778 201.191 137.778L202.654 138.363C202.654 138.363 205.493 132.33 205.939 131.575C206.384 130.82 206.303 123.107 206.303 123.107V123.101Z",
    fill: "url(#paint78_linear_6386_338502)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M206.052 112.998C206.303 112.268 208.494 112.425 208.494 112.425C208.494 112.425 209.587 118.439 209.185 123.529C208.494 132.311 208.356 138.552 207.86 138.609C207.364 138.659 205.38 138.514 205.38 138.514C205.38 138.514 206.165 129.593 206.259 126.322C206.441 119.66 206.052 112.998 206.052 112.998Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M208.495 112.425C208.495 112.425 209.204 116.319 209.267 120.497L207.063 120.534C207.063 120.534 206.899 115.533 206.567 112.589C207.295 112.337 208.488 112.425 208.488 112.425H208.495Z",
    fill: "#ECEBF1"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M200.23 128.348C200.054 128.084 199.91 127.838 199.803 127.618C199.087 126.152 201.511 123.686 202.937 120.981C203.257 120.566 203.835 120.616 204.588 121.233C204.268 122.17 202.296 125.919 200.23 128.348Z",
    fill: "url(#paint79_linear_6386_338502)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M200.556 127.134C200.456 127.134 200.349 127.102 200.268 127.033L199.577 126.492C199.369 126.328 199.338 126.033 199.495 125.831C199.658 125.624 199.954 125.592 200.154 125.75L200.845 126.291C201.053 126.454 201.084 126.75 200.927 126.951C200.833 127.071 200.695 127.134 200.556 127.134Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M201.473 125.624C201.373 125.624 201.279 125.592 201.191 125.529L200.406 124.938C200.198 124.781 200.154 124.485 200.311 124.278C200.468 124.07 200.764 124.026 200.971 124.183L201.756 124.775C201.963 124.932 202.007 125.227 201.85 125.435C201.756 125.561 201.618 125.624 201.473 125.624Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M202.428 124.089C202.327 124.089 202.233 124.057 202.145 123.994L201.392 123.435C201.184 123.277 201.14 122.982 201.291 122.774C201.448 122.566 201.743 122.522 201.951 122.673L202.704 123.233C202.911 123.391 202.955 123.686 202.805 123.894C202.71 124.02 202.572 124.083 202.428 124.083V124.089Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M203.401 122.541C203.313 122.541 203.232 122.516 203.15 122.472L202.353 121.975C202.133 121.837 202.064 121.547 202.202 121.327C202.34 121.107 202.629 121.038 202.849 121.176L203.646 121.673C203.866 121.811 203.935 122.101 203.797 122.321C203.709 122.466 203.552 122.541 203.395 122.541H203.401Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5478 93.9421C68.5478 93.9421 74.3506 108.814 74.6458 121.887L69.9106 123.441L68.5478 93.9421Z",
    fill: "#EEA601"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8946 92.7342C67.8946 92.7342 66.4313 89.6265 63.5927 89.985C49.2238 91.7906 65.7342 130.77 68.5792 131.984C71.4241 133.198 98.7301 119.383 98.7301 119.383L98.3784 117.106L71.983 122.34C71.983 122.34 70.8651 96.3579 67.8883 92.7405L67.8946 92.7342Z",
    fill: "url(#paint80_linear_6386_338502)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M103.528 151.744C112.521 150.587 142.735 129.965 142.735 129.965L191.683 135.079L192.486 129.128C177.477 125.177 144.349 116.615 139.306 116.628C134.364 116.64 100.074 128.417 100.074 128.417C100.074 128.417 94.5287 152.902 103.528 151.744Z",
    fill: "url(#paint81_linear_6386_338502)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M69.069 88.6765L67.8632 88.8778C67.8632 88.8778 72.0458 95.1436 77.5723 96.3515C80.0844 96.8989 76.7496 91.564 76.7496 91.564L74.897 90.4946C74.6332 90.375 74.3632 90.2555 74.068 90.1234C72.1274 89.2678 70.4758 88.7645 69.0627 88.6827L69.069 88.6765Z",
    fill: "url(#paint82_linear_6386_338502)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0626 134.846C82.0626 134.846 85.5544 140.943 86.4838 143.144C87.4133 145.346 91.3635 154.594 104.546 151.53C117.728 148.467 118.688 114.979 118.688 114.979C118.688 114.979 126.985 126.096 133.629 137.426L139.463 134.67C136.116 120.308 128.573 91.8786 121.282 91.866C109.099 91.8534 94.221 130.569 94.221 130.569L82.0689 134.846H82.0626Z",
    fill: "url(#paint83_linear_6386_338502)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9735 116.087C55.1899 116.087 53.4629 115.608 51.8866 114.652C48.6146 112.671 46.6866 108.959 47.0822 105.43C47.3146 103.36 48.5769 99.5977 54.4175 97.6538C54.6624 97.572 54.9324 97.7041 55.0141 97.9558C55.0957 98.2011 54.9638 98.4716 54.7126 98.5534C50.7561 99.8682 48.376 102.347 48.018 105.536C47.66 108.713 49.4122 112.054 52.3764 113.847C55.6295 115.822 59.6174 115.52 63.3164 113.017C63.5299 112.872 63.8251 112.928 63.9696 113.142C64.114 113.356 64.0575 113.652 63.844 113.797C61.5957 115.319 59.2406 116.08 56.9798 116.08L56.9735 116.087Z",
    fill: "url(#paint84_linear_6386_338502)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2097 84.0714L63.1783 83.1278C70.9405 82.8572 76.0149 80.7812 78.2569 76.95C81.3593 71.6655 78.238 64.3427 76.7496 61.4362L76.6994 61.3356L77.5409 60.9078L77.5912 61.0084C79.5255 64.7894 82.2887 71.9423 79.0733 77.4281C76.6554 81.555 71.3173 83.7883 63.2159 84.0714H63.2097Z",
    fill: "url(#paint85_linear_6386_338502)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3299 79.2713L70.9845 78.3969C73.6598 77.3337 75.569 75.4841 76.6617 72.9048C78.2004 69.2749 77.6665 65.2297 76.9694 63.5248L77.8424 63.1663C78.6274 65.0787 79.1926 69.3504 77.5284 73.2697C76.3351 76.0881 74.2501 78.1075 71.3299 79.2713Z",
    fill: "url(#paint86_linear_6386_338502)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4578 64.0785C80.053 62.5749 83.8336 64.154 83.8336 64.154C85.3409 50.018 74.2376 49.8355 71.154 52.3268C68.9183 54.1323 69.6468 56.265 68.5478 56.9948C67.4487 57.7308 64.3526 54.6671 61.1749 57.0199C57.6894 59.593 60.4024 63.3676 59.7493 64.2043C59.0961 65.0347 51.8237 63.0719 49.3305 67.268C45.4934 73.7415 53.2996 79.0826 52.2822 80.2213C51.2648 81.36 67.0719 99.3524 73.1637 83.8638C74.9723 79.2588 69.9671 74.4776 70.4506 73.7038C70.9342 72.93 75.9772 72.8104 77.2144 69.9984C78.4515 67.1863 77.654 64.8334 78.4515 64.0848L78.4578 64.0785Z",
    fill: "url(#paint87_linear_6386_338502)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4743 76.2768C71.625 74.5719 70.3627 73.0684 68.6608 72.9174C66.9589 72.7664 65.4579 74.0309 65.3072 75.7358C65.1565 77.4406 66.4188 78.9442 68.1207 79.0952C69.8226 79.2462 71.3236 77.9817 71.4743 76.2768Z",
    fill: "#D66855"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2183 76.1636C70.3062 75.1507 69.5589 74.2637 68.5478 74.1693C67.5367 74.0813 66.6512 74.8299 66.557 75.8427C66.469 76.8556 67.2164 77.7426 68.2275 77.837C69.2386 77.9314 70.1241 77.1765 70.2183 76.1636Z",
    fill: "#C04F40"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5744 75.9308C67.2352 76.5347 67.4488 77.3023 68.0516 77.6483C68.2275 77.7489 68.4159 77.793 68.6043 77.8055L69.9294 80.0766C70.1053 80.3786 70.4946 80.4792 70.7961 80.3031H70.8086C71.1101 80.1206 71.2106 79.7306 71.0347 79.4223L69.7347 77.2016C69.7347 77.2016 69.7536 77.1827 69.7598 77.1701C70.099 76.5662 69.8854 75.7987 69.2826 75.4527C68.6797 75.113 67.9135 75.3269 67.5681 75.9308H67.5744Z",
    fill: "#ECEBF1"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M50.932 100.39C50.932 100.39 50.8817 100.39 50.8503 100.384C44.8025 99.3587 41.6311 95.5652 42.3596 90.2367C43.0755 85.0214 47.704 79.6174 53.2117 80.1962C53.4691 80.2213 53.6575 80.4541 53.6324 80.712C53.6073 80.97 53.3749 81.1587 53.1175 81.1335C48.2817 80.6239 43.9484 85.5876 43.2953 90.3625C42.6422 95.1248 45.5248 98.522 51.0073 99.4531C51.2648 99.4971 51.4344 99.7424 51.3904 99.9941C51.3527 100.227 51.1518 100.384 50.9257 100.384L50.932 100.39Z",
    fill: "url(#paint88_linear_6386_338502)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1065 142.182C95.0625 142.182 95.0186 142.182 94.9809 142.163C94.7485 142.1 94.6041 141.867 94.6418 141.635C95.6026 135.727 91.1877 134.217 90.9993 134.161C90.7544 134.079 90.6162 133.815 90.6978 133.569C90.7795 133.324 91.0433 133.186 91.2882 133.267C91.3321 133.28 95.2007 134.601 95.6717 139.137C97.3046 135.262 100.771 127.278 104.734 119.415C112.195 104.631 117.841 97.3015 121.521 97.6349C123.329 97.7985 126.143 102.378 129.892 111.255C133.095 118.842 136.285 128.071 138.226 135.343C138.295 135.595 138.144 135.853 137.893 135.922C137.642 135.991 137.384 135.84 137.315 135.589C132.957 119.232 124.202 98.8239 121.439 98.5723C121.376 98.5723 121.314 98.566 121.257 98.566C114.594 98.566 100.47 129.757 95.5461 141.892C95.4708 142.075 95.2949 142.188 95.1128 142.188L95.1065 142.182Z",
    fill: "url(#paint89_linear_6386_338502)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M155.597 202.651C154.975 202.651 154.416 202.211 154.284 201.576C148.858 174.883 137.315 155.726 119.963 144.642C106.857 136.262 92.8017 134.167 83.3124 133.884C72.9816 133.569 65.6777 135.287 65.6024 135.306C64.8802 135.476 64.158 135.035 63.9884 134.312C63.8188 133.588 64.2584 132.865 64.9807 132.695C65.2884 132.619 72.6424 130.896 83.2936 131.198C93.1345 131.481 107.73 133.645 121.376 142.364C139.375 153.858 151.333 173.606 156.909 201.047C157.06 201.777 156.589 202.482 155.861 202.633C155.773 202.651 155.679 202.658 155.591 202.658L155.597 202.651Z",
    fill: "url(#paint90_linear_6386_338502)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8946 92.7342C67.8946 92.7342 66.4314 89.6265 63.5927 89.985C55.1459 91.0482 57.3754 104.958 61.2188 116.489L71.512 114.426C70.9342 106.468 69.7912 95.043 67.8946 92.7342Z",
    fill: "url(#paint91_linear_6386_338502)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5975 158.306C76.2535 158.306 74.9096 158.161 73.5907 157.859C64.4092 155.777 59.4102 146.774 59.8874 139.269C60.3019 132.708 64.5159 128.411 71.1666 127.769C72.6738 127.624 73.9864 127.769 75.0917 128.128C88.908 113.658 76.8564 92.0799 71.5874 82.6496C70.6579 80.9888 69.9294 79.674 69.5714 78.8247C69.4709 78.5856 69.584 78.3088 69.8226 78.2082C70.0613 78.1075 70.3376 78.2207 70.4381 78.4598C70.7709 79.2588 71.4932 80.5484 72.4038 82.1841C77.7482 91.7465 89.9254 113.558 76.0337 128.499C77.8738 129.38 79.0105 130.883 79.4061 132.456C80.009 134.846 78.9037 137.092 76.6617 138.036C74.8782 138.785 72.7931 138.055 71.7067 136.3C70.7144 134.695 70.5951 132.173 73.2265 129.895C73.6033 129.568 73.9738 129.235 74.3192 128.895C73.4274 128.675 72.4038 128.593 71.2482 128.706C65.1 129.298 61.2 133.267 60.8169 139.326C60.3647 146.435 65.1 154.965 73.7917 156.934C79.3622 158.199 85.4476 156.582 90.0698 152.619C95.6089 147.869 101.895 137.602 100.413 115.634C100.394 115.376 100.589 115.149 100.853 115.13C101.104 115.111 101.336 115.306 101.355 115.571C102.862 137.923 96.3876 148.448 90.6853 153.336C86.9297 156.557 82.2385 158.299 77.5912 158.299L77.5975 158.306ZM75.3366 129.229C74.8656 129.694 74.3695 130.16 73.8482 130.613C71.6627 132.5 71.7255 134.532 72.5105 135.803C73.2328 136.967 74.7651 137.816 76.2975 137.168C78.3762 136.293 78.8974 134.287 78.4955 132.689C78.1438 131.292 77.0825 129.958 75.3366 129.229Z",
    fill: "#ECEBF1"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1036 122.025C96.9215 122.025 96.7394 121.981 96.5761 121.887C96.0423 121.591 95.8538 120.924 96.1427 120.39L107.73 99.3838C108.025 98.8491 108.69 98.6603 109.224 98.9497C109.758 99.2454 109.946 99.9123 109.658 100.447L98.0707 121.453C97.8698 121.818 97.493 122.019 97.1099 122.019L97.1036 122.025Z",
    fill: "#1A305D"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6234 108.43C98.2654 110.915 97.0282 112.004 96.3625 112.991C95.6968 113.979 95.1379 117.521 92.921 118.15L93.9258 121.39C93.9258 121.39 101.022 120.541 101.801 118.918C102.027 118.439 101.933 117.722 102.109 116.98C102.178 116.691 102.655 116.489 102.649 116.087C102.649 115.564 102.247 115.439 102.266 115.023C102.297 114.294 103.07 114.073 102.881 113.3C102.699 112.557 98.7113 113.017 98.7113 113.017C98.7113 113.017 99.9925 110.23 99.7727 109.267C99.6282 108.651 98.6359 108.437 98.6359 108.437L98.6234 108.43Z",
    fill: "url(#paint92_linear_6386_338502)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M242.545 156.054C242.495 156.054 242.439 156.047 242.382 156.022C242.137 155.934 242.012 155.664 242.1 155.418C243.437 151.738 251.156 143.163 263.471 136.451C273.934 130.751 290.658 124.781 310.936 128.706C311.194 128.757 311.357 129.002 311.307 129.26C311.257 129.518 311.012 129.688 310.754 129.631C290.752 125.756 274.248 131.651 263.917 137.275C251.809 143.868 244.266 152.191 242.979 155.733C242.91 155.922 242.728 156.041 242.539 156.041L242.545 156.054Z",
    fill: "url(#paint93_linear_6386_338502)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M232.409 162.238C231.216 162.238 230.098 161.502 229.665 160.313C229.106 158.79 229.885 157.111 231.404 156.551L245.353 151.423C247.902 150.297 251.344 149.813 254.591 150.134L272.916 151.92C272.916 151.92 272.979 151.927 273.01 151.933C284.93 153.487 292.711 150.574 298.225 142.49L324.759 103.605C325.669 102.271 327.491 101.925 328.822 102.838C330.154 103.75 330.499 105.574 329.588 106.908L303.055 145.793C296.241 155.783 286.463 159.583 272.301 157.746L254.026 155.966C251.746 155.745 249.303 156.066 247.664 156.809C247.601 156.84 247.532 156.865 247.469 156.89L233.427 162.055C233.094 162.175 232.755 162.238 232.422 162.238H232.409Z",
    fill: "url(#paint94_linear_6386_338502)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M308.148 202.651C307.457 202.651 306.873 202.123 306.81 201.425C306.791 201.255 305.673 189.748 298.131 178.23C288.026 162.804 271.78 154.638 249.843 153.965C249.102 153.94 248.518 153.323 248.543 152.581C248.568 151.839 249.177 151.266 249.925 151.279C262.497 151.669 273.456 154.525 282.5 159.772C289.76 163.987 295.795 169.737 300.442 176.858C308.336 188.962 309.442 200.701 309.486 201.192C309.548 201.934 309.002 202.582 308.267 202.651C308.229 202.651 308.186 202.651 308.148 202.651Z",
    fill: "url(#paint95_linear_6386_338502)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M226.242 202.651C226.154 202.651 226.066 202.645 225.972 202.626C225.244 202.475 224.779 201.771 224.923 201.041C230.5 173.593 242.458 153.852 260.456 142.358C274.103 133.645 288.698 131.475 298.539 131.191C309.197 130.889 316.544 132.613 316.852 132.689C317.574 132.859 318.014 133.588 317.844 134.305C317.675 135.029 316.946 135.476 316.23 135.299C316.155 135.281 308.851 133.569 298.52 133.878C289.037 134.161 274.976 136.256 261.869 144.635C244.524 155.726 232.975 174.883 227.548 201.569C227.417 202.205 226.858 202.645 226.236 202.645L226.242 202.651Z",
    fill: "url(#paint96_linear_6386_338502)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M260.318 15.9016H258.836V29.1443H260.318V15.9016Z",
    fill: "url(#paint97_linear_6386_338502)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M334.889 15.9016H333.407V29.1443H334.889V15.9016Z",
    fill: "url(#paint98_linear_6386_338502)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M260.318 39.7573H258.836V52.9999H260.318V39.7573Z",
    fill: "url(#paint99_linear_6386_338502)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M334.889 39.7573H333.407V52.9999H334.889V39.7573Z",
    fill: "url(#paint100_linear_6386_338502)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M342.167 -1.75732H251.011V15.8954H342.167V-1.75732Z",
    fill: "url(#paint101_linear_6386_338502)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M278.261 2.16199H271.509C270.667 2.16199 269.983 2.84642 269.983 3.69071V10.4536C269.983 11.2979 270.667 11.9823 271.509 11.9823H278.261C279.103 11.9823 279.787 11.2979 279.787 10.4536V3.69071C279.787 2.84642 279.103 2.16199 278.261 2.16199Z",
    fill: "url(#paint102_linear_6386_338502)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M306.842 4.15625H288.19C287.694 4.15625 287.292 4.55902 287.292 5.05587V9.18909C287.292 9.68594 287.694 10.0887 288.19 10.0887H306.842C307.338 10.0887 307.74 9.68594 307.74 9.18909V5.05587C307.74 4.55902 307.338 4.15625 306.842 4.15625Z",
    fill: "url(#paint103_linear_6386_338502)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M333.25 4.15625H314.598C314.102 4.15625 313.7 4.55902 313.7 5.05587V9.18909C313.7 9.68594 314.102 10.0887 314.598 10.0887H333.25C333.746 10.0887 334.148 9.68594 334.148 9.18909V5.05587C334.148 4.55902 333.746 4.15625 333.25 4.15625Z",
    fill: "url(#paint104_linear_6386_338502)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M260.318 11.932C260.142 11.932 259.973 11.8628 259.847 11.7244C259.602 11.4602 259.621 11.0513 259.879 10.8122L262.793 8.10077H256.199C255.841 8.10077 255.552 7.81138 255.552 7.45279C255.552 7.0942 255.841 6.80481 256.199 6.80481H264.444C264.708 6.80481 264.947 6.96838 265.047 7.21373C265.141 7.45908 265.079 7.74218 264.884 7.92462L260.764 11.7559C260.639 11.8691 260.482 11.9257 260.325 11.9257L260.318 11.932Z",
    fill: "url(#paint105_linear_6386_338502)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M264.444 8.10072C264.287 8.10072 264.137 8.0441 264.011 7.93715L259.891 4.21285C259.627 3.97379 259.602 3.56487 259.847 3.30065C260.086 3.03643 260.494 3.01126 260.758 3.25032L264.878 6.97462C265.141 7.21368 265.167 7.6226 264.922 7.88682C264.796 8.03152 264.62 8.10072 264.438 8.10072H264.444Z",
    fill: "url(#paint106_linear_6386_338502)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M272.006 4.54004C272.269 4.40164 272.489 4.31986 272.784 4.43939C273.846 4.86718 274.926 5.26351 275.994 5.67872C276.157 5.74163 276.282 5.72905 276.427 5.64098C276.791 5.42079 277.162 5.21318 277.526 5.00558C277.896 4.79168 278.298 4.88605 278.48 5.21319C278.669 5.55919 278.531 5.94295 278.141 6.14426C276.609 6.92435 275.077 7.70444 273.551 8.49082C273.268 8.63552 273.01 8.65439 272.722 8.47824C272.238 8.18256 271.736 7.92463 271.214 7.63524C271.378 7.52829 271.516 7.42134 271.66 7.33956C271.71 7.3081 271.798 7.30811 271.861 7.32698C272.188 7.40876 272.514 7.49684 272.847 7.57862C272.91 7.5912 272.998 7.60378 273.048 7.57233C273.651 7.23261 274.248 6.88661 274.876 6.52802C273.909 5.86116 272.96 5.20689 271.999 4.54633L272.006 4.54004Z",
    fill: "url(#paint107_linear_6386_338502)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M271.221 10.007V9.57916H278.562V10.007H271.221Z",
    fill: "url(#paint108_linear_6386_338502)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M342.167 22.1046H251.011V39.7573H342.167V22.1046Z",
    fill: "url(#paint109_linear_6386_338502)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M278.261 26.0239H271.509C270.667 26.0239 269.983 26.7084 269.983 27.5527V34.3155C269.983 35.1598 270.667 35.8443 271.509 35.8443H278.261C279.103 35.8443 279.787 35.1598 279.787 34.3155V27.5527C279.787 26.7084 279.103 26.0239 278.261 26.0239Z",
    fill: "url(#paint110_linear_6386_338502)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M260.318 35.7877C260.161 35.7877 260.004 35.731 259.879 35.6178L255.759 31.7866C255.564 31.6041 255.501 31.321 255.596 31.0757C255.69 30.8303 255.928 30.6667 256.199 30.6667H264.444C264.802 30.6667 265.091 30.9561 265.091 31.3147C265.091 31.6733 264.802 31.9627 264.444 31.9627H257.85L260.764 34.6741C261.028 34.9195 261.04 35.3284 260.796 35.5864C260.67 35.7248 260.494 35.794 260.325 35.794L260.318 35.7877Z",
    fill: "url(#paint111_linear_6386_338502)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M256.199 31.9564C256.023 31.9564 255.847 31.8872 255.715 31.7425C255.476 31.4783 255.495 31.0694 255.759 30.8303L259.879 27.106C260.142 26.867 260.551 26.8858 260.789 27.1563C261.028 27.4206 261.009 27.8295 260.745 28.0685L256.626 31.7928C256.5 31.9061 256.349 31.9564 256.192 31.9564H256.199Z",
    fill: "url(#paint112_linear_6386_338502)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M272.006 28.402C272.269 28.2636 272.489 28.1818 272.784 28.3013C273.846 28.7291 274.926 29.1255 275.994 29.5407C276.157 29.6036 276.282 29.591 276.427 29.5029C276.791 29.2827 277.162 29.0751 277.526 28.8675C277.896 28.6536 278.298 28.748 278.48 29.0751C278.669 29.4211 278.531 29.8049 278.141 30.0062C276.609 30.7863 275.077 31.5664 273.551 32.3528C273.268 32.4975 273.01 32.5163 272.722 32.3402C272.238 32.0445 271.736 31.7866 271.214 31.4972C271.378 31.3902 271.516 31.2833 271.66 31.2015C271.71 31.17 271.798 31.17 271.861 31.1889C272.188 31.2707 272.514 31.3588 272.847 31.4406C272.91 31.4531 272.998 31.4657 273.048 31.4343C273.651 31.0945 274.248 30.7485 274.876 30.39C273.909 29.7231 272.96 29.0688 271.999 28.4083L272.006 28.402Z",
    fill: "url(#paint113_linear_6386_338502)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M271.221 33.8626V33.4348H278.562V33.8626H271.221Z",
    fill: "url(#paint114_linear_6386_338502)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M306.842 28.0119H288.19C287.694 28.0119 287.292 28.4147 287.292 28.9115V33.0447C287.292 33.5416 287.694 33.9444 288.19 33.9444H306.842C307.338 33.9444 307.74 33.5416 307.74 33.0447V28.9115C307.74 28.4147 307.338 28.0119 306.842 28.0119Z",
    fill: "url(#paint115_linear_6386_338502)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M333.25 28.0119H314.598C314.102 28.0119 313.7 28.4147 313.7 28.9115V33.0447C313.7 33.5416 314.102 33.9444 314.598 33.9444H333.25C333.746 33.9444 334.148 33.5416 334.148 33.0447V28.9115C334.148 28.4147 333.746 28.0119 333.25 28.0119Z",
    fill: "url(#paint116_linear_6386_338502)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M342.167 45.7463H251.011V63.399H342.167V45.7463Z",
    fill: "url(#paint117_linear_6386_338502)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M260.318 59.4294C260.161 59.4294 260.004 59.3728 259.879 59.2595L255.759 55.4283C255.564 55.2458 255.501 54.9627 255.596 54.7174C255.69 54.472 255.928 54.3085 256.199 54.3085H264.444C264.802 54.3085 265.091 54.5979 265.091 54.9564C265.091 55.315 264.802 55.6044 264.444 55.6044H257.85L260.764 58.3159C261.028 58.5612 261.04 58.9701 260.796 59.2281C260.67 59.3665 260.494 59.4357 260.325 59.4357L260.318 59.4294Z",
    fill: "url(#paint118_linear_6386_338502)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M256.199 55.5981C256.023 55.5981 255.847 55.5289 255.715 55.3842C255.476 55.12 255.495 54.7111 255.759 54.472L259.879 50.7477C260.142 50.5087 260.551 50.5276 260.789 50.7981C261.028 51.0623 261.009 51.4712 260.745 51.7103L256.626 55.4346C256.5 55.5478 256.349 55.5981 256.192 55.5981H256.199Z",
    fill: "url(#paint119_linear_6386_338502)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M289.986 53.4906H272.031C271.227 53.4906 270.574 52.8364 270.574 52.0311C270.574 51.2259 271.227 50.5716 272.031 50.5716H289.986C290.79 50.5716 291.443 51.2259 291.443 52.0311C291.443 52.8364 290.79 53.4906 289.986 53.4906Z",
    fill: "url(#paint120_linear_6386_338502)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M304.21 59.3287H272.037C271.233 59.3287 270.58 58.6744 270.58 57.8692C270.58 57.0639 271.233 56.4097 272.037 56.4097H304.21C305.014 56.4097 305.667 57.0639 305.667 57.8692C305.667 58.6744 305.014 59.3287 304.21 59.3287Z",
    fill: "url(#paint121_linear_6386_338502)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M119.499 79.026C119.499 72.8105 114.468 67.7714 108.263 67.7714C102.059 67.7714 97.0282 72.8105 97.0282 79.026C97.0282 84.4426 100.853 88.9659 105.94 90.0417C106.047 90.3688 106.26 90.7463 106.587 91.1678L107.679 92.7531C107.956 93.1557 108.552 93.1557 108.829 92.7531L109.921 91.1678C110.173 90.8029 110.505 90.3877 110.882 89.9725C115.818 88.7898 119.492 84.3357 119.492 79.026H119.499Z",
    fill: "url(#paint122_linear_6386_338502)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M108.263 89.098C108.589 89.098 108.854 88.8332 108.854 88.5066C108.854 88.18 108.589 87.9153 108.263 87.9153C107.937 87.9153 107.673 88.18 107.673 88.5066C107.673 88.8332 107.937 89.098 108.263 89.098Z",
    fill: "url(#paint123_linear_6386_338502)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M110.895 75.5723H107.378V80.5736H110.895V75.5723Z",
    fill: "url(#paint124_linear_6386_338502)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M105.243 89.8341H111.397C111.397 89.8341 111.416 89.8341 111.429 89.8278V80.6617L105.243 77.252V89.8341Z",
    fill: "url(#paint125_linear_6386_338502)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M111.24 79.6237C111.115 79.3343 110.945 79.089 110.744 78.8814C110.543 78.6801 110.311 78.5165 110.06 78.3781C109.821 78.2523 109.57 78.139 109.318 78.0447C109.074 77.9503 108.841 77.8622 108.609 77.7804C108.395 77.6987 108.201 77.6169 108.031 77.5225C107.88 77.4407 107.767 77.3464 107.679 77.2331C107.61 77.145 107.579 77.0318 107.579 76.8934C107.579 76.799 107.598 76.7172 107.629 76.648C107.661 76.5788 107.704 76.5285 107.767 76.4782C107.836 76.4216 107.937 76.3775 108.056 76.3461C108.345 76.2643 108.829 76.2706 109.18 76.365C109.375 76.4216 109.551 76.4782 109.702 76.5411C109.852 76.604 109.984 76.6606 110.085 76.7172C110.374 76.8682 110.568 76.8619 110.713 76.7613C110.788 76.711 110.845 76.6355 110.882 76.5285C110.907 76.453 110.926 76.3587 110.939 76.2454C110.945 76.1511 110.951 76.0315 110.951 75.8868C110.951 75.7799 110.951 75.6855 110.945 75.6037C110.945 75.5094 110.932 75.4276 110.92 75.3647C110.901 75.2766 110.876 75.2074 110.845 75.1508C110.813 75.0879 110.769 75.025 110.706 74.9621C110.644 74.8991 110.556 74.8425 110.424 74.7796C110.317 74.7293 110.198 74.679 110.072 74.6349C109.94 74.5909 109.802 74.5468 109.658 74.5154C109.614 74.5028 109.57 74.4965 109.526 74.4839L109.632 73.4774C109.632 73.3956 109.62 73.3201 109.595 73.2509C109.57 73.1691 109.507 73.0622 109.356 72.9867C109.275 72.9489 109.18 72.9175 109.061 72.8986C108.873 72.8671 108.533 72.8671 108.358 72.8923C108.257 72.9049 108.169 72.93 108.1 72.9615C108.006 73.0055 107.943 73.0622 107.893 73.1377C107.855 73.2006 107.83 73.2698 107.818 73.3515V73.4459C107.755 73.9869 107.409 74.4588 106.907 74.6664L106.838 74.6915C106.505 74.8299 106.216 75.0187 105.984 75.2451C105.745 75.4779 105.563 75.7484 105.444 76.0567C105.318 76.365 105.255 76.7047 105.255 77.0696C105.255 77.4722 105.318 77.8245 105.437 78.1202C105.557 78.4095 105.726 78.6675 105.933 78.8751C106.134 79.0764 106.361 79.2463 106.612 79.3847C106.85 79.5168 107.095 79.63 107.34 79.7244C107.579 79.8187 107.818 79.9068 108.044 79.9886C108.251 80.0641 108.439 80.1522 108.609 80.2465C108.753 80.3283 108.873 80.429 108.954 80.5359C109.023 80.6177 109.055 80.7309 109.055 80.8756C109.055 81.1021 108.973 81.272 108.797 81.4041C108.596 81.5551 108.27 81.6306 107.824 81.6306C107.522 81.6306 107.259 81.5991 107.039 81.5425C106.813 81.4796 106.618 81.4104 106.461 81.3412C106.298 81.2657 106.172 81.1965 106.065 81.1399C105.764 80.9574 105.557 80.97 105.393 81.0707C105.305 81.121 105.236 81.2091 105.192 81.316C105.161 81.3978 105.136 81.4985 105.123 81.6306C105.111 81.7312 105.111 81.8696 105.111 82.0269C105.111 82.2471 105.123 82.4107 105.148 82.5302C105.18 82.6875 105.249 82.807 105.337 82.9014C105.406 82.9706 105.506 83.0398 105.632 83.109C105.739 83.1656 105.871 83.2222 106.021 83.2788C106.166 83.3354 106.329 83.3858 106.511 83.4298C106.605 83.455 106.7 83.4738 106.794 83.4927L106.687 84.537C106.668 84.6377 106.675 84.7383 106.712 84.8264C106.744 84.9019 106.806 85.0089 106.951 85.0781C107.026 85.1158 107.12 85.141 107.24 85.1598C107.334 85.1724 107.466 85.185 107.623 85.185C107.748 85.185 107.861 85.1787 107.937 85.1661C108.031 85.1535 108.113 85.1347 108.182 85.1032C108.282 85.0592 108.358 84.9963 108.414 84.9145C108.452 84.8516 108.471 84.7824 108.483 84.7006V84.6503C108.552 84.0149 108.986 83.5053 109.582 83.2788C109.582 83.2788 109.582 83.2788 109.589 83.2788C109.972 83.1341 110.298 82.9391 110.575 82.6937C110.851 82.4484 111.071 82.1464 111.221 81.8067C111.372 81.467 111.447 81.0832 111.447 80.6617C111.447 80.2654 111.385 79.9194 111.259 79.63L111.24 79.6237Z",
    fill: "url(#paint126_linear_6386_338502)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6386_338502",
    x1: 105.5,
    y1: 11.5,
    x2: 513.487,
    y2: 275.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.200775,
    stopColor: "#FFFCE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875416,
    stopColor: "#FFEB85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6386_338502",
    x1: -0.00000200793,
    y1: -24.5,
    x2: 353,
    y2: 302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.676454,
    stopColor: "#BCF4EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6386_338502",
    x1: 44.7397,
    y1: 28.3579,
    x2: 44.7397,
    y2: 40.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6386_338502",
    x1: 331.102,
    y1: 72.6594,
    x2: 331.102,
    y2: 84.5999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6386_338502",
    x1: 238.174,
    y1: -7.38784,
    x2: 238.174,
    y2: 9.67349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6386_338502",
    x1: 174.381,
    y1: 121.516,
    x2: 375,
    y2: 121.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3E6F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6386_338502",
    x1: 273.714,
    y1: 19.6134,
    x2: 0,
    y2: 19.6134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3E6F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6386_338502",
    x1: 0,
    y1: 33.4851,
    x2: 375,
    y2: 33.4851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6386_338502",
    x1: 0,
    y1: 191.447,
    x2: 375,
    y2: 191.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6386_338502",
    x1: 0,
    y1: 147.026,
    x2: 375,
    y2: 147.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6386_338502",
    x1: 153.907,
    y1: -59.9621,
    x2: 482.208,
    y2: 147.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6386_338502",
    x1: 1.66424,
    y1: 14.2219,
    x2: 102.467,
    y2: 250.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_6386_338502",
    x1: 241.076,
    y1: 65.582,
    x2: 243.343,
    y2: 65.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_6386_338502",
    x1: 91.1878,
    y1: 39.1345,
    x2: 419.488,
    y2: 246.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_6386_338502",
    x1: 127.889,
    y1: -18.8564,
    x2: 456.189,
    y2: 188.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_6386_338502",
    x1: 88.393,
    y1: 43.5508,
    x2: 416.693,
    y2: 251.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_6386_338502",
    x1: 74.5014,
    y1: 152.795,
    x2: 515.83,
    y2: 338.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_6386_338502",
    x1: 403.487,
    y1: 279.698,
    x2: 145.697,
    y2: 134.154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_6386_338502",
    x1: 187.5,
    y1: 187.911,
    x2: 187.5,
    y2: 145.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_6386_338502",
    x1: -2.6879,
    y1: 221.965,
    x2: 153.119,
    y2: 181.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_6386_338502",
    x1: 0.854099,
    y1: 246.261,
    x2: 52.9917,
    y2: 195.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_6386_338502",
    x1: 88.6882,
    y1: 217.303,
    x2: 227.881,
    y2: 217.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_6386_338502",
    x1: 171.599,
    y1: 235.076,
    x2: 310.409,
    y2: 202.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_6386_338502",
    x1: 15.7569,
    y1: 218.153,
    x2: 157.556,
    y2: 218.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_6386_338502",
    x1: 138.992,
    y1: 206.237,
    x2: 184.425,
    y2: 195.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E8B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DA1AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_6386_338502",
    x1: 154.887,
    y1: 154.575,
    x2: 171.096,
    y2: 154.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_6386_338502",
    x1: 154.297,
    y1: 144.484,
    x2: 171.611,
    y2: 144.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FD9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E54A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_6386_338502",
    x1: 130.238,
    y1: 176.764,
    x2: 195.181,
    y2: 176.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FD9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E54A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_6386_338502",
    x1: 134.502,
    y1: 200.097,
    x2: 140.757,
    y2: 200.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A305D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#03163B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_6386_338502",
    x1: 184.366,
    y1: -14.9999,
    x2: 190.621,
    y2: -14.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A305D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#03163B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_6386_338502",
    x1: 159.905,
    y1: 125.882,
    x2: 164.203,
    y2: 219.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FD9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E54A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_6386_338502",
    x1: 193.278,
    y1: 99.5851,
    x2: 193.278,
    y2: 152.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_6386_338502",
    x1: 181.879,
    y1: 92.3127,
    x2: 204.601,
    y2: 92.3127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FD9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E54A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_6386_338502",
    x1: 166.926,
    y1: 168.906,
    x2: 219.252,
    y2: 168.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FD9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E54A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_6386_338502",
    x1: 166.926,
    y1: 191.214,
    x2: 219.252,
    y2: 191.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FD9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E54A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_6386_338502",
    x1: 173.043,
    y1: 200.355,
    x2: 179.298,
    y2: 200.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A305D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#03163B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_6386_338502",
    x1: 207.238,
    y1: 200.355,
    x2: 213.494,
    y2: 200.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A305D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#03163B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_6386_338502",
    x1: 167.014,
    y1: 135.84,
    x2: 192.545,
    y2: 162.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FD9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E54A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_6386_338502",
    x1: 191.72,
    y1: 124.429,
    x2: 196.024,
    y2: 218.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FD9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E54A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_6386_338502",
    x1: 169.438,
    y1: 161.388,
    x2: 171.429,
    y2: 161.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_6386_338502",
    x1: 176.189,
    y1: 163.269,
    x2: 209.989,
    y2: 163.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FD9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E54A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_6386_338502",
    x1: 192.606,
    y1: 124.385,
    x2: 196.91,
    y2: 218.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FD9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E54A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_6386_338502",
    x1: 179.348,
    y1: 158.117,
    x2: 181.339,
    y2: 158.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_6386_338502",
    x1: 189.409,
    y1: 173.643,
    x2: 209.399,
    y2: 173.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_6386_338502",
    x1: 191.281,
    y1: 174.858,
    x2: 207.427,
    y2: 174.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFCA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_6386_338502",
    x1: 192.964,
    y1: 176.286,
    x2: 202.472,
    y2: 176.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_6386_338502",
    x1: 200.732,
    y1: 171.429,
    x2: 204.802,
    y2: 171.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_6386_338502",
    x1: 197.41,
    y1: 176.487,
    x2: 214.172,
    y2: 176.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_6386_338502",
    x1: 198.785,
    y1: 177.475,
    x2: 212.426,
    y2: 177.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFCA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_6386_338502",
    x1: 203.571,
    y1: 175.65,
    x2: 207.64,
    y2: 175.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_6386_338502",
    x1: 205.267,
    y1: 176.487,
    x2: 209.336,
    y2: 176.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_6386_338502",
    x1: 207.088,
    y1: 177.475,
    x2: 211.157,
    y2: 177.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_6386_338502",
    x1: 190.376,
    y1: 124.491,
    x2: 194.681,
    y2: 218.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FD9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E54A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_6386_338502",
    x1: 169.438,
    y1: 187.245,
    x2: 171.429,
    y2: 187.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_6386_338502",
    x1: 172.629,
    y1: 187.245,
    x2: 174.619,
    y2: 187.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_6386_338502",
    x1: 178.733,
    y1: 137.331,
    x2: 207.427,
    y2: 137.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FD9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E54A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_6386_338502",
    x1: 110.455,
    y1: 102.058,
    x2: 101.814,
    y2: 113.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7D3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F58C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_6386_338502",
    x1: 69.1318,
    y1: 177.185,
    x2: 121.841,
    y2: 177.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_6386_338502",
    x1: 70.8714,
    y1: 120.736,
    x2: 58.9954,
    y2: 99.0426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A305D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#03163B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_6386_338502",
    x1: 51.7484,
    y1: 132.286,
    x2: 152.356,
    y2: 132.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DB4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3D6FD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242783"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_6386_338502",
    x1: 72.3535,
    y1: 176.965,
    x2: 133.302,
    y2: 176.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_6386_338502",
    x1: 98.3848,
    y1: 134.205,
    x2: 199.853,
    y2: 134.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7D3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F58C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_6386_338502",
    x1: 90.8674,
    y1: 106.071,
    x2: 68.8877,
    y2: 69.7553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A305D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#03163B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_6386_338502",
    x1: 72.1902,
    y1: 109.657,
    x2: 101.104,
    y2: 109.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7D3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F58C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_6386_338502",
    x1: 82.0626,
    y1: 122.006,
    x2: 141.24,
    y2: 122.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7D3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F58C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_6386_338502",
    x1: 65.3135,
    y1: 87.6007,
    x2: 77.5724,
    y2: 87.6007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7D3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F58C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_6386_338502",
    x1: 61.8845,
    y1: 111.758,
    x2: 96.6828,
    y2: 111.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFCA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_6386_338502",
    x1: 74.9347,
    y1: 90.3814,
    x2: 72.4839,
    y2: 82.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7D3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F58C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_6386_338502",
    x1: 67.6372,
    y1: 72.9614,
    x2: 85.052,
    y2: 72.9614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7D3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F58C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_6386_338502",
    x1: 90.5597,
    y1: 78.2396,
    x2: 86.1185,
    y2: 77.0231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7D3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F58C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_6386_338502",
    x1: 141.674,
    y1: 136.646,
    x2: 142.531,
    y2: 145.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_6386_338502",
    x1: 132.461,
    y1: 146.365,
    x2: 140.763,
    y2: 146.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FD9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E54A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_6386_338502",
    x1: 141.027,
    y1: 149.039,
    x2: 156.734,
    y2: 149.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FD9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E54A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_6386_338502",
    x1: 155.829,
    y1: 141.188,
    x2: 140.202,
    y2: 147.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FD9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E54A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_6386_338502",
    x1: 154.196,
    y1: 144.208,
    x2: 148.955,
    y2: 146.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FD9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E54A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_6386_338502",
    x1: 198.685,
    y1: 127.763,
    x2: 206.629,
    y2: 127.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_6386_338502",
    x1: 200.512,
    y1: 134.576,
    x2: 206.428,
    y2: 134.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FD9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E54A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_6386_338502",
    x1: 198.296,
    y1: 121.566,
    x2: 206.598,
    y2: 121.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FD9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E54A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_6386_338502",
    x1: 211.007,
    y1: 134.18,
    x2: 203.219,
    y2: 129.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FD9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E54A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_6386_338502",
    x1: 199.853,
    y1: 119.578,
    x2: 201.629,
    y2: 123.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FD9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E54A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_6386_338502",
    x1: 57.8024,
    y1: 111.01,
    x2: 98.7364,
    y2: 111.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7D3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F58C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_6386_338502",
    x1: 252.525,
    y1: 139.408,
    x2: 152.714,
    y2: 135.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0EDE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#95EDE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DC9E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_6386_338502",
    x1: 67.8695,
    y1: 92.5329,
    x2: 78.5081,
    y2: 92.5329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7D3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F58C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_6386_338502",
    x1: 149.097,
    y1: 130.782,
    x2: 104.997,
    y2: 121.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0EDE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#95EDE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DC9E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_6386_338502",
    x1: 47.032,
    y1: 106.858,
    x2: 64.0449,
    y2: 106.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A305D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#03163B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_6386_338502",
    x1: 63.172,
    y1: 72.4896,
    x2: 80.5429,
    y2: 72.4896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A305D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#03163B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_6386_338502",
    x1: 70.9845,
    y1: 71.2188,
    x2: 78.6086,
    y2: 71.2188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A305D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#03163B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_6386_338502",
    x1: 103.955,
    y1: 94.4139,
    x2: 40.7543,
    y2: 49.8382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A305D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#03163B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_6386_338502",
    x1: 42.2591,
    y1: 90.2744,
    x2: 53.6387,
    y2: 90.2744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A305D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#03163B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_6386_338502",
    x1: 138.433,
    y1: 74.553,
    x2: 116.255,
    y2: 129.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0EDE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#95EDE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DC9E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_6386_338502",
    x1: 63.957,
    y1: 166.906,
    x2: 156.941,
    y2: 166.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DB4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3D6FD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242783"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_6386_338502",
    x1: 57.8024,
    y1: 103.221,
    x2: 71.5183,
    y2: 103.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFCA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_6386_338502",
    x1: 102.693,
    y1: 110.745,
    x2: 93.2725,
    y2: 121.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7D3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F58C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_6386_338502",
    x1: 242.074,
    y1: 141.748,
    x2: 311.319,
    y2: 141.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DB4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3D6FD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242783"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_6386_338502",
    x1: 229.483,
    y1: 132.286,
    x2: 330.097,
    y2: 132.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DB4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3D6FD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242783"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_6386_338502",
    x1: 248.543,
    y1: 176.965,
    x2: 309.492,
    y2: 176.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_6386_338502",
    x1: 224.898,
    y1: 166.906,
    x2: 317.888,
    y2: 166.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DB4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3D6FD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242783"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_6386_338502",
    x1: 258.836,
    y1: 22.5261,
    x2: 260.318,
    y2: 22.5261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A305D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#03163B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_6386_338502",
    x1: 333.407,
    y1: 22.5261,
    x2: 334.889,
    y2: 22.5261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A305D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#03163B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_6386_338502",
    x1: 258.836,
    y1: 46.3817,
    x2: 260.318,
    y2: 46.3817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A305D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#03163B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_6386_338502",
    x1: 333.407,
    y1: 46.3817,
    x2: 334.889,
    y2: 46.3817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A305D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#03163B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_6386_338502",
    x1: 251.011,
    y1: 7.07531,
    x2: 342.167,
    y2: 7.07531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0EDE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#95EDE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DC9E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_6386_338502",
    x1: 269.983,
    y1: 7.0753,
    x2: 279.787,
    y2: 7.0753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#DEF9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95EDE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_6386_338502",
    x1: 287.292,
    y1: 7.11933,
    x2: 307.74,
    y2: 7.11933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#DEF9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95EDE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_6386_338502",
    x1: 313.7,
    y1: 7.11933,
    x2: 334.148,
    y2: 7.11933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#DEF9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95EDE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_6386_338502",
    x1: 252.788,
    y1: 9.49738,
    x2: 275.962,
    y2: 8.93941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#DEF9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95EDE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_6386_338502",
    x1: 252.7,
    y1: 5.82336,
    x2: 275.874,
    y2: 5.2654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#DEF9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95EDE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_6386_338502",
    x1: 271.221,
    y1: 6.49027,
    x2: 278.562,
    y2: 6.49027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0EDE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#95EDE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DC9E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_6386_338502",
    x1: 271.221,
    y1: 9.79306,
    x2: 278.562,
    y2: 9.79306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0EDE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#95EDE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DC9E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_6386_338502",
    x1: 251.011,
    y1: 30.931,
    x2: 342.167,
    y2: 30.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0EDE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#95EDE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DC9E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_6386_338502",
    x1: -0.000275803,
    y1: 30.9309,
    x2: 0.627739,
    y2: 30.9309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#DEF9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95EDE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_6386_338502",
    x1: 253.084,
    y1: 32.9189,
    x2: 271.152,
    y2: 33.5145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#DEF9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95EDE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_6386_338502",
    x1: 251.972,
    y1: 29.591,
    x2: 272.527,
    y2: 29.1271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#DEF9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95EDE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_6386_338502",
    x1: 271.221,
    y1: 30.3522,
    x2: 278.562,
    y2: 30.3522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0EDE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#95EDE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DC9E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_6386_338502",
    x1: 271.221,
    y1: 33.6487,
    x2: 278.562,
    y2: 33.6487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0EDE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#95EDE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DC9E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_6386_338502",
    x1: 287.292,
    y1: 30.9813,
    x2: 307.74,
    y2: 30.9813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#DEF9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95EDE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_6386_338502",
    x1: 313.7,
    y1: 30.9813,
    x2: 334.148,
    y2: 30.9813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#DEF9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95EDE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_6386_338502",
    x1: 238.419,
    y1: 54.5727,
    x2: 365.454,
    y2: 54.5727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFCA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_6386_338502",
    x1: 256.99,
    y1: 56.9067,
    x2: 267.534,
    y2: 56.5995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_6386_338502",
    x1: 256.877,
    y1: 53.1258,
    x2: 267.427,
    y2: 52.8248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_6386_338502",
    x1: 270.58,
    y1: 52.0311,
    x2: 291.443,
    y2: 52.0311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_6386_338502",
    x1: 270.58,
    y1: 57.8692,
    x2: 305.667,
    y2: 57.8692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_6386_338502",
    x1: 108.263,
    y1: 94.9864,
    x2: 108.263,
    y2: 70.4451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFCA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_6386_338502",
    x1: 108.263,
    y1: 91.2999,
    x2: 108.263,
    y2: 84.3986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1C379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#F19169"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74967"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_6386_338502",
    x1: 109.13,
    y1: 87.7203,
    x2: 109.13,
    y2: 75.2451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFCA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_6386_338502",
    x1: 108.332,
    y1: 96.2572,
    x2: 108.332,
    y2: 75.8679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFCA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_6386_338502",
    x1: 108.263,
    y1: 88.2991,
    x2: 108.263,
    y2: 27.0746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#CAE0E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D9FB9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6386_338502"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 250,
    fill: "white",
    transform: "translate(0 -15)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountProduct);
export default __webpack_public_path__ + "static/media/account-product.25efd62b56a04cc0c7b16822b3262b8a.svg";
export { ForwardRef as ReactComponent };